<template>
  <div v-if="reservationResult && !isLoading" class="container">
    <div v-if="reservationResult.status === 200" class="result-card">
      <h1>Success</h1>
      <p>You should receive a reservation text message in a few minutes.</p>
      <table>
        <tr>
          <th>NAME</th>
          <td>{{reservationResult.data.booking[0].name}}</td>
        </tr>
        <tr>
          <th>TEL.</th>
          <td>{{reservationResult.data.booking[0].tel}}</td>
        </tr>
        <tr>
          <th>ROOM</th>
          <td>{{reservationResult.data.room[0].name}}</td>
        </tr>
        <tr>
          <th>DATE</th>
          <td>{{reservationResult.data.booking[0].date}} ~ {{reservationResult.data.booking[reservationResult.data.booking.length-1].date}}</td>
        </tr>
      </table>
      <div class="btn-wrapper">
        <button @click="back">back</button>
        <button @click="toHome">Home</button>
      </div>
    </div>
    <div v-if="reservationResult.status != 200" class="result-card">
      <h1>Oops...</h1>
      <p>{{reservationResult.data.message}}</p>
      <div class="btn-wrapper">
        <button @click="back">back</button>
        <button @click="toHome">Home</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["reservationResult", "isLoading"])
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  background-image: url("https://images.unsplash.com/photo-1551776235-dde6d482980b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
  display: flex;
  justify-content: center;
  align-items: center;
}
.result-card {
  margin: var(--g-xl);
  padding: var(--g-xl) var(--g-xxl);
  display: flex;
  flex-flow: column;
  align-items: center;
  box-shadow: 0 0 10px var(--text-color-darker) inset;
  max-width: 800px;
  background-color: white;
}
h1 {
  margin: var(--g-xl) 0;
}
table {
  th,
  td {
    text-align: left;
    padding: var(--g-m);
  }
  th {
    font-weight: bold;
  }
  td {
    color: var(--text-color-lighter);
  }
}
.btn-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  margin: var(--g-xl) 0;
  width: 100%;
}
button {
  &:hover {
    cursor: pointer;
  }
  &:active {
    background-color: var(--text-color-lightest);
    color: var(--text-color-darker);
  }
  position: relative;
  margin: var(--g-m);
  border: none;
  outline: none;
  background-color: black;
  text-transform: uppercase;
  color: white;
  font-weight: bold;
  padding: var(--g-s) var(--g-m);
  align-self: flex-end;
  border-radius: var(--g-s);
  font-size: var(--fs-m);
  &.disabled {
    cursor: initial;
    background-color: var(--color-alert);
  }
}
</style>